<template>
    <mySubPage>
        <div slot="header">
            <myNav>{{$t('upd_admin_code')}}</myNav>
            <div class="sn-info-box">
                <el-row>
                    <el-col :span="12">
                        {{$t('org_cname')}}{{$t('x_mh')}}<span class="f-blue">{{org_cname}}</span>
                    </el-col>
                    <el-col :span="12">
                        {{$t('old_user_code')}}{{$t('x_mh')}}<span class="f-blue">{{admin_code}}</span>
                    </el-col>
                </el-row>
            </div>
        </div>
        <el-form class="pd-10" ref="form" :model="formData" :rules="rule" label-width="120px">
            <el-form-item :label="$t('new_user_code')" prop="admin_code">
                <el-input v-model="formData.admin_code" :placeholder="$t('input')"/>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <div class="flex-box bg-f8">
                <div class="flex-box-bd"></div>
                <el-button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</el-button>
                <el-button type="primary" @click="submit">{{$t('save')}}</el-button>
            </div>
        </div>
    </mySubPage>
</template>

<script>
    export default {
        data:function(){
            return{
                relist: false,
                formData: {
                    org_id: '',
                    admin_code: ''
                },
                rule: {
                    admin_code: [{required: true, message: this.$t('input'), trigger: 'blur'}]
                },
                org_cname: '',
                admin_code: ''
            }
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            var info = this.$base.getRequest();
            this.formData.org_id = info.org_id;
            this.org_cname = info.org_cname;
            this.admin_code = info.admin_code;
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            submit: function(){
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        this.$base.showLoading();
                        this.$request.sendPost("org-shop/upd-admin",this.formData,(success,data,error)=>{
                            this.$base.hideLoading();
                            if(success){
                                this.$base.msgSuccess(error.errmsg);
                                this.relist = true;
                                this.$base.linkBack();
                            }
                            else{
                                this.$base.alertErr(error.errmsg);
                            }
                        });
                    } else {
                        this.$base.alertErr(this.$t('incomplete'));
                    }
                })
            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/org/shop/admin.vue